// src/api/authApi.js
import { http } from '../lib/http';
const u = (p) => `/api${p.startsWith('/') ? '' : '/'}${p}`;


/**
 * Login user
 */
export const loginUser = (credentials) =>
    http.post(u('/auth/login'), credentials);

/**
 * Refresh access token using refresh token cookie
 */
export const refreshToken = () => http.post(u('/auth/refresh'));

/**
 * Logout user and clear refresh token cookie
 */
export const logoutUser = () => http.post(u('/auth/logout'));
/**
 * Verify current password before account deletion
 */
export const verifyDeleteAccountPassword = (password, accessToken) =>
  http.post(
    u('/auth/verify-delete-account-password'),
    { password },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

/**
 * Permanently delete the authenticated account
 */
export const deleteAccount = (deletionToken, accessToken) =>
  http.post(
    u('/auth/delete-account'),
    { deletionToken },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
/**
 * Fetch user's saved itineraries
 */
export const fetchMyItineraries = (accessToken) =>
   http.get(u('/saved-itineraries/user-full'), {
      headers: { Authorization: `Bearer ${accessToken}` },
    });

/**
 * Fetch public roam-share content
 */
export const fetchRoamShareContent = () => http.get(u('/roam-share'));

export const signupUser = (userData) =>
   http.post(u('/auth/signup'), userData);

export const verifyOtp = (data) =>
    http.post(u('/auth/verify-otp'), data);

export const resendOtp = (email) =>
    http.post(u('/auth/resend-otp'), { email });

export const saveUserItinerary = async (
  tripData,
  editableItinerary,
  title,
  accessToken,
  setAccessToken,
) => {
  const trySave = (token) =>
        http.post(
          u('/saved-itineraries/save-full'),
          { tripData, editableItinerary, title },
          { headers: { Authorization: `Bearer ${token}` } }
        );
    
      try {
        return await trySave(accessToken);
      } catch (err) {
        if (err.status === 401 || err.status === 403) {
          try {
            const refreshData = await refreshToken();
            const newAccessToken = refreshData.accessToken;
            if (setAccessToken) setAccessToken(newAccessToken);
            return await trySave(newAccessToken);
          } catch {
            throw new Error('Session expired. Please log in again.');
          }
        }
        throw err;
      }
};

export const fetchUserSavedItineraries = (accessToken) =>
    http.get(u('/saved-itineraries/user-full'), {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
/**
 * Delete user's saved itinerary
 */
export const deleteUserItinerary = async (savedId, accessToken) => {
    await http.del(u(`/saved-itineraries/${savedId}`), {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return true;
  };
